import React, { useCallback, useMemo, useRef, useState } from 'react';
import {BsTrash} from 'react-icons/bs';
import {Table} from "../../Components/Tables/Table";
import {useDataCollectionRequest, useForm} from "../../Hooks";
import {AgGridReact} from 'ag-grid-react/lib/agGridReact';
import { SearchDataToTable } from '../../Components/SearchDataToTable';

export const ConsultationByLegalRepresentative = () => {
    
    const gridRef = useRef();

    const { dataCollectionRequest: getMandatarioJudicial  } = useDataCollectionRequest('obtener_jueces', 'all');

    const { formState, onResetForm, onInputChange } = useForm({});
    
    const containerStyle = useMemo(() => ({ width: '100%', height: 'calc(100vh - 200px)', margin: "auto" }), []);
    const gridStyle = useMemo(() => ({ height: '85%', width: '100%'}), []);

    const defaultColDef = useMemo(()=> {
        return {
            flex: 1,
            minWidth: 100,
            width: 150,
            resizable: true,
            sortable: true,
            //floatingFilter: true,
        }
    },[])

    const onGridReady = useCallback(()=> {

    },[])

    const onFilterLegalRepresentative = useCallback((e) => {
        gridRef.current.api.setQuickFilter(e.target.value);
    }, []);

    return (
        <div style={containerStyle} className="container container-md">
            
            <h2 className="text-center m-3">Consulta por Mandatario judicial</h2>

            <form className="row row-cols-2 mb-3">

                <SearchDataToTable name={'Buscar mandatario judicial:' } onFilter={onFilterLegalRepresentative} />

            </form>

            <div style={gridStyle} className={'ag-theme-alpine'}>
                <AgGridReact
                    ref={gridRef}
                    defaultColDef={defaultColDef}
                    onGridReady={onGridReady}
                    columnDefs={[
                        { field: 'id', headerName: 'ID', hide: true, },
                        { field: 'nombre', headerName: 'Nombre', },
                        { field: 'correo', headerName: 'Correo', },
                    ]}
                    rowData={getMandatarioJudicial || []}

                />
            </div>

        </div>
    );
}
